import { render, staticRenderFns } from "./upload_foto_perfil.vue?vue&type=template&id=3ebfe3a7"
import script from "./upload_foto_perfil.vue?vue&type=script&lang=js"
export * from "./upload_foto_perfil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports